import EntityCrudPage from '../../shared/EntityCrudPage';
import { businessProcessConfig } from '../../config/entityConfigs';

const BusinessProcessesPage = () => <EntityCrudPage config={businessProcessConfig} />;

export default BusinessProcessesPage;
